import { render, staticRenderFns } from "./BaseModal.vue?vue&type=template&id=a417c6de&scoped=true"
import script from "./BaseModal.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseModal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./BaseModal.vue?vue&type=style&index=0&id=a417c6de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a417c6de",
  null
  
)

export default component.exports